export const HISTORY_LOAD_COINFLIP = Symbol('HISTORY_LOAD_COINFLIP')
export const HISTORY_LOAD_COINFLIP_SUCCESS = Symbol('HISTORY_LOAD_COINFLIP_SUCCESS')
export const HISTORY_LOAD_COINFLIP_FAILURE = Symbol('HISTORY_LOAD_COINFLIP_FAILURE')

export const HISTORY_LOAD_JACKPOT = Symbol('HISTORY_LOAD_JACKPOT')
export const HISTORY_LOAD_JACKPOT_SUCCESS = Symbol('HISTORY_LOAD_JACKPOT_SUCCESS')
export const HISTORY_LOAD_JACKPOT_FAILURE = Symbol('HISTORY_LOAD_JACKPOT_FAILURE')
